/**
 * Superadmin chat export: show when the message has at least one completed signature
 * (`signedAt` on a signatureRequests entry). Backend bundles all EV-* for the message.
 * @param {object} message - Message from API/store
 * @returns {boolean}
 */
export default function messageHasExportableOmmnioSignEvidence(message) {
  if (!message?.digitalSignature) return false;
  return (
    Array.isArray(message.signatureRequests) &&
    message.signatureRequests.some(sr => Boolean(sr.signedAt))
  );
}
